<template>
    <InformeCard title="Venta abonos" id="venta_abonos" name="venta_abonos" collapsable="true">
        <div class="table-responsive">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th>TIPO DE PRECIO</th>
                        <th>MÉTODO DE PAGO</th>
                        <th>CONCEPTO</th>
                        <th>VENDIDAS</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(venta, index) in informe">
                        <tr :key="index">
                            <td>ABONO</td>
                            <td>{{ venta.metodo_pago | formatear_metodo_pago }}</td>
                            <td>{{ venta.description }}</td>
                            <td>{{ venta.total }}</td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="3">TOTAL</td>
                        <td>{{ getTotalVendidas() }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id', 'informe'],
        methods: {
            getTotalVendidas() {
                var total = 0;
                for (var i = 0; i < this.informe.length; i++) {
                    total = total + this.informe[i].total;
                }

                return total;
            },
            getRecaudacionTotal() {
                var total = 0;
                for (var i = 0; i < this.informe.length; i++) {
                    var rec = this.informe[i].total * this.informe[i].importe
                    total = total + rec;
                }

                return total;
            }
        },
        components: {
            InformeCard,
        }
    }
</script>
